import { Edit } from "@mui/icons-material";
import { Autocomplete, Checkbox, FormControlLabel, FormGroup, TextField } from "@mui/material";
import React, { useContext, useState } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import "./Classification.css";
const Classification = (props) => {

    const { setDocumentData, data = {}, duplicateDocumentView, classificationMappingData = {}, setDataSave } = useContext(DocumentDetailContext);
    const [editMode, setEditMode] = useState(true);

    const mapCategory = (sub_category) => {
        var sub_category_val = sub_category ? sub_category : data.Entity_Details.classify
            .documentSubCategory;
        return {
            docClassification: classificationMappingData[sub_category_val]?.category.display_name,
            documentSubCategory: sub_category_val,
            documentLevel: classificationMappingData[sub_category_val]?.doc_level.display_name
        };
    };

    const getSubCategoryOptions = (data) => {
        let optionArray = Object.keys(data || {}).map(m => {
            return {
                label: m,
                id: m,
                disable: !data[m]?.enabled
            }
        });
        let enabledOptions = optionArray.filter(m => !m.disable);
        let disabledOptions = optionArray.filter(m => m.disable);
        return [...enabledOptions, ...disabledOptions]
    }

    const handleCategory = (sub_category, reason) => {
        if (reason != "selectOption") {
            return 0;
        }
        let classify = mapCategory(sub_category);
        data.Entity_Details.classify = { ...data.Entity_Details.classify, ...classify }
        data.Entity_Details.classModify = true
        setDocumentData({ ...data });
        setDataSave(true);
    }

    const handleEditIconClick = () => {
        setEditMode(true);
    }

    return <div className="category-display">
        <div
            className={data.Entity_Details.classModify ? "card-flag" : "card-flag-hide"}
        >
            <div className="tri-flag" />
        </div>
        <div className="each-category" style={{width: "30%"}}>
            <div className="icon-text">
                <div className="label-font" style={{ marginTop: "0px", marginRight: "15px" }}>
                    Category
                </div>
            </div>
            <div className="value-font">{data?.Entity_Details?.classify?.docClassification || ""}</div>
        </div>
        <div className="each-category" style={{width: "70%"}}>
            <div className="label-font" style={{ marginTop: "0px" }}>
                Sub-Category
            </div>
            {editMode ? <Autocomplete
                options={getSubCategoryOptions(classificationMappingData)}
                name="subCategory"
                value={data?.Entity_Details?.classify?.documentSubCategory || ""}
                onChange={(event, newValue, reason) =>
                    handleCategory(newValue?.label, reason)
                }
                getOptionDisabled={(option) => option?.disable}
                sx={{ width: "100%" }}
                renderInput={(params) => (
                    <TextField {...params} variant="standard" label="" />
                )}
            /> : <div className="value-font">{data?.Entity_Details?.classify?.documentSubCategory || ""}</div>}
        </div>
        {!editMode && <Edit
            className={"icon-review-style"}
            onClick={(e) =>
                !duplicateDocumentView && handleEditIconClick()
            }
            fontSize="small"
        />}
    </div>
}

export default Classification;